import { createApi } from "@reduxjs/toolkit/query/react";
import { components } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

// Define the response type for the currencies endpoint
type GetCurrenciesResponse = components["schemas"]["CurrencyInfo"][];

export const currencyApi = createApi({
  reducerPath: "currencyApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Currencies"],
  endpoints: (builder) => ({
    // Get all available currencies
    getCurrencies: builder.query<GetCurrenciesResponse, void>({
      query: () => "/currencies",
      providesTags: ["Currencies"],
    }),
  }),
});

export const { useGetCurrenciesQuery } = currencyApi;
